import React from 'react'

import Button from '@components/Content/Button/Button'
import Wysiwyg from '@components/Content/Wysiwyg/Wysiwyg'
import NewsletterForm from '@components/Newsletter/NewsletterForm'

import { SidebarType } from '@contracts/pages/newsSingle'

import * as styles from './NewsSidebar.module.scss'

type Props = {
	data: SidebarType
	heroImageRef?: React.RefObject<HTMLDivElement>
}

const NewsSidebar: React.FC<Props> = ({ data, heroImageRef }) => {
	const [overlapping, setOverlapping] = React.useState(true)

	const sidebarRef = React.useRef<HTMLDivElement>(null)

	React.useEffect(() => {
		const detectOverlapping = () => {
			if (heroImageRef && heroImageRef.current && sidebarRef.current) {
				const heroRect = heroImageRef.current.getBoundingClientRect()
				const sidebarRect = sidebarRef.current.getBoundingClientRect()

				const isOverlapping =
					heroRect.right + 32 > sidebarRect.left &&
					heroRect.left - 32 < sidebarRect.right &&
					heroRect.bottom + 32 > sidebarRect.top &&
					heroRect.top - 32 < sidebarRect.bottom

				setOverlapping(isOverlapping)
			}
		}

		window.addEventListener('scroll', detectOverlapping)

		detectOverlapping()
	}, [heroImageRef, sidebarRef.current])

	const { ctaOrNewsletter, title, content, button } = data

	return (
		<div
			className={`${styles.sidebar} ${
				ctaOrNewsletter === undefined || ctaOrNewsletter === 'newsletter' ? styles.newsletter : styles.cta
			} ${overlapping ? styles.overlapping : ''}`}
			ref={sidebarRef}
		>
			{ctaOrNewsletter === undefined ||
				(ctaOrNewsletter === 'newsletter' && (
					<div>
						<NewsletterForm />
					</div>
				))}

			{ctaOrNewsletter === 'cta' && title && content && (
				<div>
					<h3 className={styles.title}>{title}</h3>

					<Wysiwyg data={content} />

					{button && <Button data={button} className={styles.button} />}
				</div>
			)}
		</div>
	)
}

export default NewsSidebar
